export default __webpack_public_path__ + "static/individuals-4-c07db3da52bb4f3b532cd62d9deaa4a3.jpg";